<div class="login-page">
  <div class="box-white">
    <h1>Redefinir senha</h1>
    <p class="subtitle">Informe sua nova senha. Ela deve ter no mínimo 8 caracteres, com letra maiúscula, número e caractere especial.</p>

    <form *ngIf="!success && token" (ngSubmit)="submit()" [formGroup]="form" class="p-field">
      <div class="form-control" [ngClass]="{'invalid': isInvalid(form.get('newPassword'))}">
        <i class="icon pi pi-lock"></i>
        <span class="p-float-label">
          <input type="password" formControlName="newPassword" id="newPassword" name="newPassword" pInputText autocomplete="new-password">
          <label for="newPassword">Nova senha *</label>
        </span>
      </div>
      <div class="form-control" [ngClass]="{'invalid': isInvalid(form.get('confirmPassword')) || hasPasswordError()}">
        <i class="icon pi pi-lock"></i>
        <span class="p-float-label">
          <input type="password" formControlName="confirmPassword" id="confirmPassword" name="confirmPassword" pInputText autocomplete="new-password">
          <label for="confirmPassword">Confirmar nova senha *</label>
        </span>
        <small *ngIf="hasPasswordError()" class="p-error">As senhas não conferem.</small>
      </div>
      <div class="buttons">
        <button type="submit" [disabled]="!form.valid" class="easy-button full-width" pButton label="Redefinir senha"></button>
      </div>
    </form>

    <div *ngIf="success" class="success-block">
      <i class="pi pi-check-circle success-icon"></i>
      <p class="success-message">Sua senha foi alterada com sucesso. Faça login com a nova senha.</p>
      <button type="button" class="easy-button" pButton label="Ir para o login" (click)="goToLogin()"></button>
    </div>

    <div *ngIf="message" class="alert text-center error-message" [ngClass]="success ? 'alert-success' : 'alert-danger'">
      <strong>{{ message }}</strong>
    </div>

    <div *ngIf="!success" class="back-link">
      <a routerLink="/login">Voltar ao login</a>
    </div>
  </div>
</div>
